import React from 'react';
import { _PaymentStatus } from "../styles";
var PaymentPending = function PaymentPending() {
  return /*#__PURE__*/React.createElement(_PaymentStatus, null, "Payment pending");
};
export default PaymentPending;